import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-753a490b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-[250px] max350:w-[200px] mx-auto" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo mx-auto mt-2.5" }, null, -1))
const _hoisted_5 = { class: "w-full flex flex-col font-semibold text-lg text-gary-text-sub-title-color" }
const _hoisted_6 = { class: "flex-1 text-center justify-center my-[10px]" }
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_9 = { class: "flex w-[250px] max350:w-[200px]" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex my-2" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "pt-2 mx-2 flex-1 border-b border-t-0 max-w-full max-h-0 border-black-300-color" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-black-300-color text-xs font-normal" }, "or"),
  /*#__PURE__*/_createElementVNode("hr", { class: "pt-2 mx-2 flex-1 border-b border-t-0 max-w-full max-h-0 border-black-300-color" })
], -1))
const _hoisted_11 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_12 = { class: "flex flex-col w-[250px] max350:w-[200px]" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] pt-4 text-light-gary-text-color font-light" }, [
  /*#__PURE__*/_createTextVNode(" 登入即代表同意 "),
  /*#__PURE__*/_createElementVNode("span", { class: "border-b-[1px]" }, "會員條款"),
  /*#__PURE__*/_createTextVNode(" 與 "),
  /*#__PURE__*/_createElementVNode("span", { class: "border-b-[1px]" }, "隱私權條款")
], -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo mx-auto mt-2.5" }, null, -1))
const _hoisted_16 = { class: "w-full flex flex-col font-semibold text-lg text-gary-text-sub-title-color" }
const _hoisted_17 = { class: "flex-1 text-center justify-center my-2.5 mt-[40px]" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[250px] max350:w-[200px] mb-2 mx-auto text-left font-light text-breadcrumb-color tracking-widest text-sm" }, " 手機號碼 ", -1))
const _hoisted_19 = { class: "w-[250px] max350:w-[200px] mx-auto text-left font-light text-breadcrumb-color tracking-widest text-sm" }
const _hoisted_20 = { class: "mt-5" }
const _hoisted_21 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_22 = { class: "flex w-[250px] max350:w-[200px]" }
const _hoisted_23 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_24 = { class: "flex flex-col w-[250px] max350:w-[200px]" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-b-[1px]" }, "忘記密碼？", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "w-[248px] mx-auto" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo mx-auto mt-2.5" }, null, -1))
const _hoisted_32 = { class: "w-full flex flex-col font-semibold text-lg text-gary-text-sub-title-color" }
const _hoisted_33 = { class: "flex-1 text-center justify-center my-2.5 mt-[40px]" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[250px] max350:w-[200px] mb-2 mx-auto text-left font-light text-breadcrumb-color tracking-widest text-sm" }, " 手機號碼 ", -1))
const _hoisted_35 = { class: "w-[250px] max350:w-[200px] mx-auto text-left font-light text-breadcrumb-color tracking-widest text-sm" }
const _hoisted_36 = { class: "mt-5" }
const _hoisted_37 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_38 = { class: "flex w-[250px] max350:w-[200px] gap-3" }
const _hoisted_39 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_40 = { class: "flex flex-col" }
const _hoisted_41 = { class: "text-[11px] text-light-gary-text-color font-light" }
const _hoisted_42 = {
  key: 0,
  class: "border-b-[1px]"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] text-light-gary-text-color font-light cursor-pointer" }, " 點擊[下一步]代表您同意使用手機號碼 ", -1))
const _hoisted_44 = { class: "text-[11px] text-light-gary-text-color font-light cursor-pointer" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 建立帳號，若您不同意，請點擊 ")
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo mx-auto mt-2.5" }, null, -1))
const _hoisted_48 = { class: "w-full flex flex-col font-semibold text-lg text-gary-text-sub-title-color" }
const _hoisted_49 = { class: "flex-1 text-center justify-center my-2.5 mt-[40px]" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[250px] max350:w-[200px] mb-2 mx-auto text-left font-light text-breadcrumb-color tracking-widest text-sm" }, " 手機號碼 ", -1))
const _hoisted_51 = { class: "w-[250px] max350:w-[200px] mx-auto text-left font-light text-breadcrumb-color tracking-widest text-sm" }
const _hoisted_52 = { class: "mt-5" }
const _hoisted_53 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_54 = { class: "flex w-[250px] max350:w-[200px]" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full flex text-center justify-center flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-[250px] max350:w-[200px]" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] text-light-gary-text-color font-light cursor-pointer tracking-[.1em]" }, " 恭喜！即將完成註冊，加入懶人世界！ ")
  ])
], -1))
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo mx-auto mt-2.5" }, null, -1))
const _hoisted_59 = { class: "pt-2 w-[250px] max350:w-[200px] text-xs tracking-[.1em] text-light-gary-text-color text-center" }
const _hoisted_60 = { class: "w-full flex flex-col font-semibold text-lg text-gary-text-sub-title-color" }
const _hoisted_61 = { class: "my-[40px] flex-1 text-center justify-center" }
const _hoisted_62 = { class: "" }
const _hoisted_63 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_64 = { class: "flex w-[250px] max350:w-[200px]" }
const _hoisted_65 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_66 = { class: "flex flex-col" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] text-light-gary-text-color font-light" }, " 點擊[下一步]代表您同意使用手機號碼 ", -1))
const _hoisted_68 = { class: "text-[11px] text-light-gary-text-color font-light" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" 建立帳號，若您不同意，請點擊 ")
const _hoisted_70 = { key: 1 }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo mx-auto mt-2.5" }, null, -1))
const _hoisted_72 = { class: "pt-2 w-[250px] max350:w-[200px] text-xs tracking-[.1em] text-light-gary-text-color text-center" }
const _hoisted_73 = { class: "w-full flex flex-col font-semibold text-lg text-gary-text-sub-title-color" }
const _hoisted_74 = { class: "flex-1 text-center justify-center my-2.5 mt-[40px]" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[250px] max350:w-[200px] mb-2 mx-auto text-left font-light text-breadcrumb-color tracking-widest text-sm" }, " 手機號碼 ", -1))
const _hoisted_76 = { class: "w-[250px] max350:w-[200px] mx-auto text-left font-light text-breadcrumb-color tracking-widest text-sm" }
const _hoisted_77 = { class: "mt-5" }
const _hoisted_78 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_79 = { class: "flex w-[250px] max350:w-[200px]" }
const _hoisted_80 = { class: "w-full flex text-center justify-center flex-wrap" }
const _hoisted_81 = { class: "flex flex-col" }
const _hoisted_82 = { class: "text-[11px] text-light-gary-text-color font-light" }
const _hoisted_83 = {
  key: 0,
  class: "border-b-[1px]"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] text-light-gary-text-color font-light" }, " 點擊[下一步]代表您同意使用手機號碼 ", -1))
const _hoisted_85 = { class: "text-[11px] text-light-gary-text-color font-light" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" 建立帳號，若您不同意，請點擊 ")
const _hoisted_87 = { key: 2 }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "flex flex-1 px-[35px] flex-col text-center justify-center" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-8" }, "忘記密碼", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-8 text-breadcrumb-color text-[0.8125rem] tracking-[.1em] font-light" }, " 系統已將驗證碼寄送至您的手機，請填寫提交驗證碼 ", -1))
const _hoisted_92 = { class: "text-right" }
const _hoisted_93 = { class: "text-[11px] text-light-gary-text-color font-light" }
const _hoisted_94 = {
  key: 0,
  class: "border-b-[1px]"
}
const _hoisted_95 = { class: "flex gap-3 right-0 w-full mt-8" }
const _hoisted_96 = { class: "basis-full" }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { class: "flex flex-1 px-[35px] flex-col text-center justify-center" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-8" }, "重新設定登入密碼", -1))
const _hoisted_100 = { class: "flex gap-3 right-0 w-full mt-8" }
const _hoisted_101 = { class: "basis-full" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 flex-col text-left justify-center text-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "未收到驗證碼？"),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-8 text-sm font-light" }, [
    /*#__PURE__*/_createTextVNode(" 系統郵件可能被視為垃圾郵件，請您"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 前往查看垃圾信箱。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 若等待3 - 5分鐘，如仍未收到訊息，"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 點選重新發送驗證碼。"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "驗證碼失敗？"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-light" }, [
    /*#__PURE__*/_createTextVNode(" 請於提出後30分鐘內，完成提交驗證碼！"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 30分鐘後，驗證碼即自動失效。若尚未完"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 成驗證碼，煩請重新發送驗證碼。"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_IConButton = _resolveComponent("IConButton")!
  const _component_Password = _resolveComponent("Password")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalBase, {
      show: _ctx.store.state.showLoginModal,
      class: "g-login-modal modal-440-width"
    }, {
      body: _withCtx(() => [
        _createVNode(_component_Icon, {
          iconName: "modal-close",
          class: "absolute top-4 right-4 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {
          _ctx.resetStatus();
          _ctx.store.setShowLoginModal(false);
        }, ["stop"]))
        }),
        (_ctx.contentType === _ctx.LoginModalContentType.LOGIN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.loginStep === _ctx.LoginStep.STEP1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_Input, {
                              ref: "accountInputRef",
                              label: '手機號碼・快速通關',
                              class: "under-line w-[250px] max350:w-[200px] mb-5",
                              width: '100%',
                              inputType: 'number',
                              placeholder: "請輸入手機號碼",
                              modelValue: _ctx.account,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.account) = $event)),
                              onKeyup: _withKeys(_ctx.verifyRegisterMobile, ["enter"])
                            }, null, 8, ["modelValue", "onKeyup"])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_Btn, {
                                text: "註冊｜登入",
                                width: "100%",
                                height: "36px",
                                fontSize: '14px',
                                onClick: _ctx.verifyRegisterMobile
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ]),
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_IConButton, {
                              class: "my-3",
                              text: 'Login with FACEBOOK',
                              iconName: "facebook_login",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkFBLoginState()))
                            }),
                            _hoisted_13
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loginStep === _ctx.LoginStep.STEP2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.account), 1),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_Password, {
                              ref: "passwordInputRef",
                              label: '密碼',
                              class: "under-line mb-5",
                              width: '250px',
                              placeholder: "輸入8~12碼英數字",
                              modelValue: _ctx.password,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.login()), ["enter"]))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_Btn, {
                                class: "text-sm",
                                text: "登入",
                                width: "100%",
                                height: "36px",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.login()))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", {
                              class: "text-[11px] text-light-gary-text-color font-light cursor-pointer",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getResetPasswordAuthCode && _ctx.getResetPasswordAuthCode(...args)))
                            }, _hoisted_26)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.contentType === _ctx.LoginModalContentType.REGISTER)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                (_ctx.accountType === _ctx.AccountContentType.G_GIFT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (_ctx.registerStep === _ctx.RegisterStep.STEP1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.account), 1),
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_component_Input, {
                                    label: '簡訊驗證碼',
                                    class: "under-line mb-5",
                                    width: '250px',
                                    placeholder: "輸入4位數驗證碼",
                                    modelValue: _ctx.verifyCode,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.verifyCode) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createVNode(_component_Btn, {
                                      class: "text-sm",
                                      text: "上一步",
                                      width: "100%",
                                      height: "36px",
                                      onClick: _ctx.resetStatus
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_Btn, {
                                      class: "text-sm",
                                      text: "下一步",
                                      width: "100%",
                                      height: "36px",
                                      onClick: _ctx.verifyRegisterSMSCode
                                    }, null, 8, ["onClick"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    (_ctx.timeRange > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.timeRange) + "s後重發驗證碼", 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.timeRange == 0)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: "cursor-pointer text-gary-text-color",
                                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sendingRegisterSMS && _ctx.sendingRegisterSMS(...args)))
                                        }, " 重新取得驗證碼 "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _hoisted_43,
                                  _createElementVNode("div", _hoisted_44, [
                                    _hoisted_45,
                                    _createElementVNode("span", {
                                      class: "border-b-[1px]",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.contentType = _ctx.LoginModalContentType.LOGIN))
                                    }, "取消註冊")
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.registerStep === _ctx.RegisterStep.STEP2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _hoisted_47,
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _hoisted_50,
                                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.account), 1),
                                _createElementVNode("div", _hoisted_52, [
                                  _createVNode(_component_Password, {
                                    label: '密碼',
                                    class: "under-line mb-5",
                                    width: '250px',
                                    placeholder: "輸入8~12碼英數字",
                                    modelValue: _ctx.password,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.password) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createVNode(_component_Btn, {
                                      class: "text-sm",
                                      text: "完成加入",
                                      width: "100%",
                                      height: "36px",
                                      onClick: _ctx.registerGiftMember
                                    }, null, 8, ["onClick"])
                                  ])
                                ])
                              ]),
                              _hoisted_55
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.accountType !== _ctx.AccountContentType.G_GIFT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      (_ctx.registerStep === _ctx.RegisterStep.STEP1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _hoisted_58,
                            _createElementVNode("div", _hoisted_59, " 您已透過" + _toDisplayString(_ctx.accountType) + "加入，請驗證手機號碼完成帳號開通 ", 1),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, [
                                  _createVNode(_component_Input, {
                                    label: '手機號碼・快速通關',
                                    class: "under-line w-[250px] max350:w-[200px] mb-5",
                                    width: '100%',
                                    inputType: 'number',
                                    placeholder: "請輸入手機號碼",
                                    modelValue: _ctx.account,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.account) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("div", _hoisted_64, [
                                    _createVNode(_component_Btn, {
                                      class: "text-sm",
                                      text: "下一步",
                                      width: "100%",
                                      height: "36px",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => {
                          _ctx.sendingRegisterSMS();
                          _ctx.registerStep = _ctx.RegisterStep.STEP2;
                        })
                                    })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                  _hoisted_67,
                                  _createElementVNode("div", _hoisted_68, [
                                    _hoisted_69,
                                    _createElementVNode("span", {
                                      class: "border-b-[1px] cursor-pointer",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetStatus()))
                                    }, "取消註冊")
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.registerStep === _ctx.RegisterStep.STEP2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _hoisted_71,
                            _createElementVNode("div", _hoisted_72, " 您已透過" + _toDisplayString(_ctx.accountType) + "加入，請驗證手機號碼完成帳號開通 ", 1),
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _hoisted_75,
                                _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.account), 1),
                                _createElementVNode("div", _hoisted_77, [
                                  _createVNode(_component_Input, {
                                    label: '簡訊驗證碼',
                                    class: "under-line w-[250px] max350:w-[200px] mb-5",
                                    width: '100%',
                                    placeholder: "輸入4位數驗證碼",
                                    modelValue: _ctx.verifyCode,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.verifyCode) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_78, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _createVNode(_component_Btn, {
                                      class: "text-sm",
                                      text: "下一步",
                                      width: "100%",
                                      height: "36px",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.verifyTpaRegisterSMSCode()))
                                    })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, [
                                  _createElementVNode("div", _hoisted_82, [
                                    (_ctx.timeRange > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_ctx.timeRange) + "s後重發驗證碼", 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.timeRange == 0)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: "cursor-pointer text-gary-text-color",
                                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sendingRegisterSMS()))
                                        }, " 重新取得驗證碼 "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _hoisted_84,
                                  _createElementVNode("div", _hoisted_85, [
                                    _hoisted_86,
                                    _createElementVNode("span", {
                                      class: "border-b-[1px] cursor-pointer",
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.resetStatus()))
                                    }, "取消註冊")
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.contentType === _ctx.LoginModalContentType.FORGOT_PASSWORD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
              (_ctx.forgetPasswordStep === _ctx.ForgotPasswordStep.STEP1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _hoisted_91,
                      _createVNode(_component_Input, {
                        label: '驗證碼',
                        class: "under-line w-[250px] max350:w-[200px] mb-5",
                        width: '100%',
                        required: true,
                        placeholder: "請輸入驗證碼",
                        modelValue: _ctx.verifyCode,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.verifyCode) = $event))
                      }, {
                        "label-icon": _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "inline-block cursor-pointer",
                            width: "16px",
                            iconName: "question-circle",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.descriptionModal = true))
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          (_ctx.timeRange > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(_ctx.timeRange) + "s後重發驗證碼", 1))
                            : _createCommentVNode("", true),
                          (_ctx.timeRange == 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "cursor-pointer text-gary-text-color",
                                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.sendingRegisterSMS && _ctx.sendingRegisterSMS(...args)))
                              }, " 重新取得驗證碼 "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createVNode(_component_Btn, {
                            class: "text-sm",
                            text: '下一步',
                            height: '36px',
                            width: '100%',
                            onClick: _ctx.verifyResetPasswordAuthCode
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.forgetPasswordStep === _ctx.ForgotPasswordStep.STEP3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, [
                      _hoisted_99,
                      _createVNode(_component_Password, {
                        label: '設定密碼',
                        class: "under-line w-[250px] max350:w-[200px] mb-5",
                        width: '100%',
                        required: true,
                        placeholder: "輸入8~12碼英數字",
                        modelValue: _ctx.resetPassword,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.resetPassword) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Password, {
                        label: '確認密碼',
                        class: "under-line w-[250px] max350:w-[200px] mb-5",
                        width: '100%',
                        required: true,
                        placeholder: "輸入8~12碼英數字",
                        modelValue: _ctx.confirmResetPassword,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.confirmResetPassword) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("div", _hoisted_101, [
                          _createVNode(_component_Btn, {
                            class: "text-sm",
                            text: '完成',
                            height: '36px',
                            width: '100%',
                            onClick: _ctx.resetMemberPassword
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ModalBase, {
      show: _ctx.descriptionModal,
      class: "modal-320-width"
    }, {
      body: _withCtx(() => [
        _createVNode(_component_Icon, {
          iconName: "modal-close",
          class: "absolute top-4 right-4 cursor-pointer",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.descriptionModal = false))
        }),
        _hoisted_102
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}